module.exports = __webpack_public_path__ + "img/logo_full_small_white.0e7de19c.png";